(function () {
  // the script can be included by several sections on one page — init once
  if (window.__copyBtnInit) return;
  window.__copyBtnInit = true;

  const handleCopy = (btn, success) => {
    if (success) {
      btn.classList.add("copied");
      setTimeout(() => btn.classList.remove("copied"), 1000);
    } else {
      btn.classList.add("notCopied");
      setTimeout(() => btn.classList.remove("notCopied"), 1000);
    }
  };

  // legacy path also covers iframes (theme editor) where the Clipboard API is denied
  const legacyCopy = (url) => {
    const textArea = document.createElement("textarea");
    textArea.value = url;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed"; // avoid scrolling
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    let ok = false;
    try {
      ok = document.execCommand("copy");
    } catch (err) {
      ok = false;
    }

    document.body.removeChild(textArea);
    return ok;
  };

  const copyURI = (copyLink) => {
    const url = copyLink.dataset.copyHref || window.location.href;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => handleCopy(copyLink, true))
        .catch(() => handleCopy(copyLink, legacyCopy(url)));
    } else {
      handleCopy(copyLink, legacyCopy(url));
    }
  };

  // delegate so buttons re-rendered by the theme editor keep working
  document.addEventListener("click", (e) => {
    const copyLink = e.target.closest(".copy-btn");
    if (!copyLink) return;
    e.preventDefault();
    copyURI(copyLink);
  });
})();
